import { createActions } from 'redux-actions'

export const INIT_PAGE_INFO = "INIT_PAGE_INFO";

export const REQUEST_PAGE_START = "REQUEST_PAGE_START";
export const REQUEST_PAGE_SUCCESS = "REQUEST_PAGE_SUCCESS";
export const REQUEST_PAGE_FAIL = "REQUEST_PAGE_FAIL";

export const PATCH_PAGE_START = "PATCH_PAGE_START";
export const PATCH_PAGE_SUCCESS = "PATCH_PAGE_SUCCESS";
export const PATCH_PAGE_FAIL = "PATCH_PAGE_FAIL";

export const POST_PAGE_START = "POST_PAGE_START";
export const POST_PAGE_SUCCESS = "POST_PAGE_SUCCESS";
export const POST_PAGE_FAIL = "POST_PAGE_FAIL";

export const PUT_PAGE_START = "PUT_PAGE_START";
export const PUT_PAGE_SUCCESS = "PUT_PAGE_SUCCESS";
export const PUT_PAGE_FAIL = "PUT_PAGE_FAIL";

export const DELETE_PAGE_START = "DELETE_PAGE_START";
export const DELETE_PAGE_SUCCESS = "DELETE_PAGE_SUCCESS";
export const DELETE_PAGE_FAIL = "DELETE_PAGE_FAIL";

export const MULTIPLE_DELETE_PAGE_START = "MULTIPLE_DELETE_PAGE_START";
export const MULTIPLE_DELETE_PAGE_SUCCESS = "MULTIPLE_DELETE_PAGE_SUCCESS";
export const MULTIPLE_DELETE_PAGE_FAIL = "MULTIPLE_DELETE_PAGE_FAIL";

export const REQUEST_DETAIL_PAGE_START = "REQUEST_DETAIL_PAGE_START";
export const REQUEST_DETAIL_PAGE_SUCCESS = "REQUEST_DETAIL_PAGE_SUCCESS";
export const REQUEST_DETAIL_PAGE_FAIL = "REQUEST_DETAIL_PAGE_FAIL";

export const REQUEST_SECTION_LIST_START = "REQUEST_SECTION_LIST_START";
export const REQUEST_SECTION_LIST_SUCCESS = "REQUEST_SECTION_LIST_SUCCESS";
export const REQUEST_SECTION_LIST_FAIL = "REQUEST_SECTION_LIST_FAIL";

export const REQUEST_SECTION_DETAIL_START = "REQUEST_SECTION_DETAIL_START";
export const REQUEST_SECTION_DETAIL_SUCCESS = "REQUEST_SECTION_DETAIL_SUCCESS";
export const REQUEST_SECTION_DETAIL_FAIL = "REQUEST_SECTION_DETAIL_FAIL";

export const POST_SECTION_START = "POST_SECTION_START";
export const POST_SECTION_SUCCESS = "POST_SECTION_SUCCESS";
export const POST_SECTION_FAIL = "POST_SECTION_FAIL";

export const POST_SECTION_ITEM_START = "POST_SECTION_ITEM_START";
export const POST_SECTION_ITEM_SUCCESS = "POST_SECTION_ITEM_SUCCESS";
export const POST_SECTION_ITEM_FAIL = "POST_SECTION_ITEM_FAIL";

export const PUT_SECTION_ITEM_START = "PUT_SECTION_ITEM_START";
export const PUT_SECTION_ITEM_SUCCESS = "PUT_SECTION_ITEM_SUCCESS";
export const PUT_SECTION_ITEM_FAIL = "PUT_SECTION_ITEM_FAIL";

export const DELETE_SECTION_ITEM_START = "DELETE_SECTION_ITEM_START";
export const DELETE_SECTION_ITEM_SUCCESS = "DELETE_SECTION_ITEM_SUCCESS";
export const DELETE_SECTION_ITEM_FAIL = "DELETE_SECTION_ITEM_FAIL";

export const PATCH_SECTION_START = "PATCH_SECTION_START";
export const PATCH_SECTION_SUCCESS = "PATCH_SECTION_SUCCESS";
export const PATCH_SECTION_FAIL = "PATCH_SECTION_FAIL";

export const PUT_SECTION_START = "PUT_SECTION_START";
export const PUT_SECTION_SUCCESS = "PUT_SECTION_SUCCESS";
export const PUT_SECTION_FAIL = "PUT_SECTION_FAIL";

export const DELETE_SECTION_START = "DELETE_SECTION_START";
export const DELETE_SECTION_SUCCESS = "DELETE_SECTION_SUCCESS";
export const DELETE_SECTION_FAIL = "DELETE_SECTION_FAIL";

export const REQUEST_PRODUCT_GROUP_START = "REQUEST_PRODUCT_GROUP_START";
export const REQUEST_PRODUCT_GROUP_SUCCESS = "REQUEST_PRODUCT_GROUP_SUCCESS";
export const REQUEST_PRODUCT_GROUP_FAIL = "REQUEST_PRODUCT_GROUP_FAIL";

export const POST_PRODUCT_GROUP_START = "POST_PRODUCT_GROUP_START";
export const POST_PRODUCT_GROUP_SUCCESS = "POST_PRODUCT_GROUP_SUCCESS";
export const POST_PRODUCT_GROUP_FAIL = "POST_PRODUCT_GROUP_FAIL";

export const PUT_PRODUCT_GROUP_START = "PUT_PRODUCT_GROUP_START";
export const PUT_PRODUCT_GROUP_SUCCESS = "PUT_PRODUCT_GROUP_SUCCESS";
export const PUT_PRODUCT_GROUP_FAIL = "PUT_PRODUCT_GROUP_FAIL";

export const DELETE_PRODUCT_GROUP_START = "DELETE_PRODUCT_GROUP_START";
export const DELETE_PRODUCT_GROUP_SUCCESS = "DELETE_PRODUCT_GROUP_SUCCESS";
export const DELETE_PRODUCT_GROUP_FAIL = "DELETE_PRODUCT_GROUP_FAIL";

export const MULTIPLE_DELETE_PRODUCT_GROUP_START = "MULTIPLE_DELETE_PRODUCT_GROUP_START";
export const MULTIPLE_DELETE_PRODUCT_GROUP_SUCCESS = "MULTIPLE_DELETE_PRODUCT_GROUP_SUCCESS";
export const MULTIPLE_DELETE_PRODUCT_GROUP_FAIL = "MULTIPLE_DELETE_PRODUCT_GROUP_FAIL";

export const REQUEST_DETAIL_PRODUCT_GROUP_START = "REQUEST_DETAIL_PRODUCT_GROUP_START";
export const REQUEST_DETAIL_PRODUCT_GROUP_SUCCESS = "REQUEST_DETAIL_PRODUCT_GROUP_SUCCESS";
export const REQUEST_DETAIL_PRODUCT_GROUP_FAIL = "REQUEST_DETAIL_PRODUCT_GROUP_FAIL";

export const DELETE_ITEM_START = "DELETE_ITEM_START";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";
export const DELETE_ITEM_FAIL = "DELETE_ITEM_FAIL";

export const {

  initPageInfo,
  requestPageStart,
  requestPageSuccess,
  requestPageFail,

  patchPageStart,
  patchPageSuccess,
  patchPageFail,

  postPageStart,
  postPageSuccess,
  postPageFail,

  putPageStart,
  putPageSuccess,
  putPageFail,

  deletePageStart,
  deletePageSuccess,
  deletePageFail,

  multipleDeletePageStart,
  multipleDeletePageSuccess,
  multipleDeletePageFail,

  requestDetailPageStart,
  requestDetailPageSuccess,
  requestDetailPageFail,

  requestSectionListStart,
  requestSectionListSuccess,
  requestSectionListFail,

  requestSectionDetailStart,
  requestSectionDetailSuccess,
  requestSectionDetailFail,

  postSectionStart,
  postSectionSuccess,
  postSectionFail,

  postSectionItemStart,
  postSectionItemSuccess,
  postSectionItemFail,

  putSectionItemStart,
  putSectionItemSuccess,
  putSectionItemFail,

  deleteSectionItemStart,
  deleteSectionItemSuccess,
  deleteSectionItemFail,

  patchSectionStart,
  patchSectionSuccess,
  patchSectionFail,

  putSectionStart,
  putSectionSuccess,
  putSectionFail,

  deleteSectionStart,
  deleteSectionSuccess,
  deleteSectionFail,

  requestProductGroupStart,
  requestProductGroupSuccess,
  requestProductGroupFail,

  postProductGroupStart,
  postProductGroupSuccess,
  postProductGroupFail,

  putProductGroupStart,
  putProductGroupSuccess,
  putProductGroupFail,

  deleteProductGroupStart,
  deleteProductGroupSuccess,
  deleteProductGroupFail,

  multipleDeleteProductGroupStart,
  multipleDeleteProductGroupSuccess,
  multipleDeleteProductGroupFail,

  requestDetailProductGroupStart,
  requestDetailProductGroupSuccess,
  requestDetailProductGroupFail,

  deleteItemStart,
  deleteItemSuccess,
  deleteItemFail,

} = createActions({

  [INIT_PAGE_INFO]: (req) => ({ req }),

  [REQUEST_PAGE_START]: (req) => ({ ...req }),
  [REQUEST_PAGE_SUCCESS]: (res) => ({ res }),
  [REQUEST_PAGE_FAIL]: (res) => ({ res }),

  [PATCH_PAGE_START]: (req) => ({ ...req }),
  [PATCH_PAGE_SUCCESS]: (res) => ({ res }),
  [PATCH_PAGE_FAIL]: (res) => ({ res }),

  [POST_PAGE_START]: (req) => ({ ...req }),
  [POST_PAGE_SUCCESS]: (res) => ({ res }),
  [POST_PAGE_FAIL]: (res) => ({ res }),

  [PUT_PAGE_START]: (req) => ({ ...req }),
  [PUT_PAGE_SUCCESS]: (res) => ({ res }),
  [PUT_PAGE_FAIL]: (res) => ({ res }),

  [DELETE_PAGE_START]: (req) => ({ ...req }),
  [DELETE_PAGE_SUCCESS]: (res) => ({ res }),
  [DELETE_PAGE_FAIL]: (res) => ({ res }),

  [MULTIPLE_DELETE_PAGE_START]: (req) => ({ ...req }),
  [MULTIPLE_DELETE_PAGE_SUCCESS]: (res) => ({ res }),
  [MULTIPLE_DELETE_PAGE_FAIL]: (res) => ({ res }),

  [REQUEST_DETAIL_PAGE_START]: (req) => ({ ...req }),
  [REQUEST_DETAIL_PAGE_SUCCESS]: (res) => ({ res }),
  [REQUEST_DETAIL_PAGE_FAIL]: (res) => ({ res }),

  [REQUEST_SECTION_LIST_START]: (req) => ({ ...req }),
  [REQUEST_SECTION_LIST_SUCCESS]: (res) => ({ res }),
  [REQUEST_SECTION_LIST_FAIL]: (res) => ({ res }),

  [REQUEST_SECTION_DETAIL_START]: (req) => ({ ...req }),
  [REQUEST_SECTION_DETAIL_SUCCESS]: (res) => ({ res }),
  [REQUEST_SECTION_DETAIL_FAIL]: (res) => ({ res }),

  [POST_SECTION_START]: (req) => ({ ...req }),
  [POST_SECTION_SUCCESS]: (res) => ({ res }),
  [POST_SECTION_FAIL]: (res) => ({ res }),

  [POST_SECTION_ITEM_START]: (req) => ({ ...req }),
  [POST_SECTION_ITEM_SUCCESS]: (res) => ({ res }),
  [POST_SECTION_ITEM_FAIL]: (res) => ({ res }),

  [PUT_SECTION_ITEM_START]: (req) => ({ ...req }),
  [PUT_SECTION_ITEM_SUCCESS]: (res) => ({ res }),
  [PUT_SECTION_ITEM_FAIL]: (res) => ({ res }),

  [DELETE_SECTION_ITEM_START]: (req) => ({ ...req }),
  [DELETE_SECTION_ITEM_SUCCESS]: (res) => ({ res }),
  [DELETE_SECTION_ITEM_FAIL]: (res) => ({ res }),

  [PATCH_SECTION_START]: (req) => ({ ...req }),
  [PATCH_SECTION_SUCCESS]: (res) => ({ res }),
  [PATCH_SECTION_FAIL]: (res) => ({ res }),

  [PUT_SECTION_START]: (req) => ({ ...req }),
  [PUT_SECTION_SUCCESS]: (res) => ({ res }),
  [PUT_SECTION_FAIL]: (res) => ({ res }),

  [DELETE_SECTION_START]: (req) => ({ ...req }),
  [DELETE_SECTION_SUCCESS]: (res) => ({ res }),
  [DELETE_SECTION_FAIL]: (res) => ({ res }),


  [REQUEST_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [REQUEST_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [REQUEST_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [POST_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [POST_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [POST_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [PUT_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [PUT_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [PUT_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [DELETE_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [DELETE_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [DELETE_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [MULTIPLE_DELETE_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [MULTIPLE_DELETE_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [MULTIPLE_DELETE_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [REQUEST_DETAIL_PRODUCT_GROUP_START]: (req) => ({ ...req }),
  [REQUEST_DETAIL_PRODUCT_GROUP_SUCCESS]: (res) => ({ res }),
  [REQUEST_DETAIL_PRODUCT_GROUP_FAIL]: (res) => ({ res }),

  [DELETE_ITEM_START]: (req) => ({ ...req }),
  [DELETE_ITEM_SUCCESS]: (res) => ({ res }),
  [DELETE_ITEM_FAIL]: (res) => ({ res }),

})


